export enum QueryStatusEnum {
  New = 'New',
  Running = 'Running',
  Canceled = 'Canceled',
  Completed = 'Completed',
  Error = 'Error'
}
